// extracted by mini-css-extract-plugin
module.exports = {"toastStyle":"Toast_toastStyle_16LBJ","toastAnimation":"Toast_toastAnimation_3Qme7"};